import CreateCoupon from "./CreateCoupon";
import CouponList from "./CouponList";

const Coupon = () => {
    return ( 
        <div>
            <CreateCoupon />
            <CouponList />
        </div>
     );
}
 
export default Coupon;